<div
  *ngFor="let u of users"
  class="user"
  [ngStyle]="{ 'background-color': u.color }"
  [matTooltip]="u.email"
  matTooltipPosition="above"
>
  {{ u.shortName }}
</div>
